<template>
    <div>
        <div class="deduplicate_item">
            <v-list-item-content class="deduplicate_item__1" @click.prevent="showDuplicates(dedup)">{{dedup.ID}}</v-list-item-content>
            <v-list-item-content class="deduplicate_item__2"  @click.prevent="showDuplicates(dedup)">{{ellespingSubject(dedup.email_subject)}}</v-list-item-content>
            <v-list-item-content class="deduplicate_item__3"  @click.prevent="showDuplicates(dedup)">{{dedup.original_sender_name}}</v-list-item-content>
            <v-list-item-content class="deduplicate_item__4" >{{dedup.original_date}}</v-list-item-content>
            <v-list-item-content class="deduplicate_item__5" >{{total_count}}</v-list-item-content>
        </div>
        <v-divider/>
    </div>
</template>

<script>
export default {
    name: 'DedupItem',
    data: () => ({
        readClass: "",
        subject_length: 125
    }),
    props: [
        "dedup",
    ],
    computed: {
        total_count: function () {
            return this.dedup.duplicates.split(',').length
        }
    },
    methods: {
      showDuplicates: function(dedupObject){
        this.$emit('showDuplicates', dedupObject)
      },
      ellespingSubject: function(subject){
        return (subject != null)?((subject.length > this.subject_length)?`${subject.substring(0, this.subject_length)}...`:subject):'';
      }
    }
}
</script>
<style lang="sass" scoped>
    @import "./../assets/sass/dedupitem.sass"
</style>
